<template>
  <CModal
    class="change-courier-modal"
    title="Change Courier for Delivered Order"
    color="dark"
    size="lg"
    :show.sync="active"
    :closeOnBackdrop="false"
  >
    <div class="alert alert-warning p-3">
      <div class="d-flex align-items-center">
        <div class="h3 mb-0 me-3">⚠️</div>
        <div class="flex-grow-1">
          <h5 class="mb-2">Warning: Order Already Delivered</h5>
          <p class="mb-0">
            This order has already been delivered. Changing the courier will only update the delivery records 
            and may affect courier statistics and payments. Please ensure this change is necessary.
          </p>
        </div>
      </div>
    </div>

    <div class="order-info mb-4">
      <h6 class="text-muted mb-2">Order Information</h6>
      <div class="row">
        <div class="col-md-6">
          <strong>Order ID:</strong> #{{ order?.id }}<br>
          <strong>Restaurant:</strong> {{ order?.restaurant?.restaurant_name }}<br>
          <strong>Address:</strong> {{ order?.roAddress }}, {{ order?.roCity }}
        </div>
        <div class="col-md-6">
          <strong>Current Courier:</strong> 
          <span v-if="currentCourier">
            {{ currentCourier.first_name }} #{{ currentCourier.id }}
          </span>
          <span v-else class="text-muted">No courier assigned</span><br>
          <strong>Delivery Time:</strong> {{ $globalFunc.formatDateTime(order?.delivery?.delivered) }}
        </div>
      </div>
    </div>

    <div class="courier-selection">
      <h6 class="mb-3">Select New Courier</h6>
      <CourierSelect
        v-model="selectedCourier"
        :couriers="availableCouriers"
        @input="onCourierSelected"
      />
      
      <div v-if="selectedCourier" class="selected-courier-info mt-3 p-3 bg-light rounded">
        <h6 class="mb-2">Selected Courier Details</h6>
        <div class="row">
          <div class="col-md-6">
            <strong>Name:</strong> {{ selectedCourier.first_name }}<br>
            <strong>ID:</strong> #{{ selectedCourier.id }}
          </div>
          <div class="col-md-6">
            <strong>Mobile:</strong> {{ selectedCourier.mobile }}<br>
            <strong>Email:</strong> {{ selectedCourier.email }}
          </div>
        </div>
      </div>
    </div>

    <template #footer class="d-flex p-1">
      <CButton @click="active = false" color="link">Cancel</CButton>

      <CButton color="success" :disabled="!selectedCourier || submitted" @click="changeCourier">
        <CSpinner v-if="submitted" size="sm" class="mr-2" />
        <CIcon name="cil-transfer" class="mt-0" />
        Change Courier
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CourierSelect from './CourierSelect.vue';

export default {
  name: "ChangeCourierForDeliveredOrder",
  components: {
    CourierSelect
  },
  props: {
    order: { type: Object, default: null },
    currentCourier: { type: Object, default: null }
  },
  data() {
    return {
      selectedCourier: null,
      availableCouriers: [],
      loading: false,
      submitted: false
    };
  },
  computed: {
    active: {
      get: function () { 
        return this.$store.state.changeCourierForDeliveredOrderShow;
      },
      set: function (newValue) { 
        this.$store.state.changeCourierForDeliveredOrderShow = newValue;
      }
    }
  },
  watch: {
    active: async function (val) {
      if (val) {
        this.selectedCourier = null;
        this.submitted = false;
        await this.loadAvailableCouriers();
      }
    }
  },
  methods: {
    async loadAvailableCouriers() {
      this.loading = true;
      
      try {
        const response = await this.$axios.get(
          this.$backend.COURIER.COURIERS.BASIC_LIST,
          {
            params: {
              'relationships': 'detail:id,user_id',
            }
          }
        );
        
        // Mevcut kuryeyi hariç tut
        this.availableCouriers = response.data.filter(
          courier => courier.id !== this.currentCourier?.id
        );
      } catch (error) {
        this.availableCouriers = [];
        this.$toast.error('Failed to load available couriers');
      } finally {
        this.loading = false;
      }
    },
    
    onCourierSelected(courier) {
      this.selectedCourier = courier;
    },
    
    async changeCourier() {
      if (!this.selectedCourier) {
        this.$toast.error('Please select a courier');
        return;
      }
      
      this.submitted = true;

      try {
        const response = await this.$axios.post(
          this.$backend.COURIER.ORDERS.CHANGE_COURIER,
          {
            "current-courier": this.currentCourier?.id || null,
            "new-courier": this.selectedCourier.id,
            "order-id": this.order.id,
          }
        );
        
        this.$toast.success(response.data.data.message);
        this.active = false;
        this.$emit("courier-changed", {
          order: this.order,
          oldCourier: this.currentCourier,
          newCourier: this.selectedCourier
        });
        
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message || 
          'Failed to change courier for delivered order'
        );
      } finally {
        this.submitted = false;
      }
    },
  }
};
</script>

<style>
.change-courier-modal .modal-header {
  padding: 1rem !important;
  border-bottom: 1px solid #dee2e6;
}

.change-courier-modal .modal-footer {
  padding: 1rem !important;
  border-top: 1px solid #dee2e6;
}

.order-info {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}

.selected-courier-info {
  border: 1px solid #dee2e6;
}

.courier-selection {
  margin-top: 1.5rem;
}
</style>
